import Rete from 'rete';

import VueButtonControl from '../../components/commons/VueButtonControl';


export default class ButtonControl extends Rete.Control {

	constructor(emitter, key, readonly, nodeID, valueNames) {
		super(key);
		this.component = VueButtonControl;
		this.props = { emitter, ikey: key, readonly, nodeID: nodeID, valueNames: valueNames};
	}

	setValue(val) {
		this.vueContext.value = val;
	}
	
	setVisibility(val) {
		this.vueContext.visibility = val;
	}

}
